<file-preview
	*ngIf="!usePdfTron"
	#filePreview
	[documents]="documents"
	[currentIndex]="currentIndex"
	[lang]="lang"
	[hideDelete]="hideDelete"
	[hideHelp]="hideHelp"
	[hideBookmarks]="hideBookmarks"
	[hideClose]="hideClose"
	[hidePrint]="hidePrint"
	[initialZoom]="initialZoom"
	(closePreview)="closeCallback()"
	(documentNav)="documentNav.emit($event)"
></file-preview>

<div class="viewer-content ng-bento" [bentoBusyLoader]="viewerIsLoading && !showDownloadModal">
	<dms-viewer
		*ngIf="usePdfTron"
		[document]="document"
		[container]="document && document.parent"
		[options]="options"
		[userDisplayAs]="userDisplayAs"
		[subscribeForNotifications]="true"
		[customStylesPath]="'dms-viewer-styles/dms-viewer.css'"
		[userContactId]="userContactId"
		[loadSavedAnnotations]="true"
		[editAnnotations]="canAddAnnotations()"
		[closeCallback]="closeCallback"
		[canPreviewDocument]="canPreviewDocument()"
		[finalizationFunctionContainer]="finalizationFunctionContainer"
		[showDownloadModal]="showDownloadModal"
		[hideDocumentPreview]="hideDocumentPreview"
		[toolbarActions]="toolbarActions"
		(documentChange)="documentNav.emit($event)"
		(loadingChange)="viewerLoadingStateChange($event.detail)"
		(downloadModalClosed)="downloadModalClosedHandler()"
		(documentUpdateAction)="documentUpdateActionHandler()"
	>
	</dms-viewer>
</div>
